// extracted by mini-css-extract-plugin
export default {"userAvatar":"UserAvatar_userAvatar__FRB1s"};